import { Dialog, DialogContent, DialogTitle, DialogContentText, DialogActions, Button } from "@mui/material";
import { useEffect, useState } from "react";
import styles from "./CallForward.module.css";
import { ArrowLeft, Plus, X } from "react-feather";
import { useAuth0 } from "@auth0/auth0-react";
import Loader from "../../../Loader";
import { toast } from "react-smart-toaster";
import Axios from "axios";
import CallForwardListing from "./components/CallForwardList";
import CallForwardAddEdit from "./components/CallForwardAddEdit";

const CallForward = (props) => {
  const [isShowAddEditForm, setIsShowAddEditForm] = useState(false);
  const [callForwardList, setCallForwardList] = useState([]);
  const [callForwardDetails, setCallForwardDetails] = useState(null);
  const [callForwardId, setCallForwardId] = useState(null);
  const [loading, setLoading] = useState(false);
  const [openCallForwardDeleteModal, setOpenCallForwardDeleteModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState("");

  const { getAccessTokenSilently } = useAuth0();

  const filteredCallForwardList = callForwardList.filter((callForward) =>
    `${callForward.title} ${callForward.description}`
      .toLowerCase()
      .includes(searchQuery.toLowerCase())
  );

  useEffect(() => {
    const fetchData = async () => {
      try {
        // setLoading(true);
        const propertyId = process.env.REACT_APP_WESTONHALL_PROPERTY_ID;
        const url = process.env.REACT_APP_PROPERTY_API_URL + "v1/property-phones/" + propertyId;
        const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
        const response = await Axios.get(url, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        console.log("response.data.data", response.data.data);
        setCallForwardList(response.data.data); // Assume response.data is an array of data

        setCallForwardDetails(null);
        // setLoading(false);
      } catch (error) {
        toast.error(error?.response?.data?.message);
      } finally {
        // setLoading(false);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (props?.isCallForwardModalOpen) {
      setCallForwardDetails(null);
    }

    if (props?.isShowCallForwardAddForm) {
      handleAddEditForm(true);
    }
  }, [props?.isCallForwardModalOpen, props?.isShowCallForwardAddForm]);

  const handleSearch = (query) => {
    setSearchQuery(query);
  };

  const AddCallForward = async (formData) => {
    try {
      setLoading(true);
      const propertyId = process.env.REACT_APP_WESTONHALL_PROPERTY_ID;
      const url = process.env.REACT_APP_PROPERTY_API_URL + "v1/property-phones/" + propertyId;
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      const response = await Axios.post(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response", response.data);
      const newCallForward = response.data.data;
      toast.success(response.data.message);
      setCallForwardList((prevList) => [newCallForward, ...prevList]);

      if (props?.isCallForwardAddForm) {
        handleCloseModal();
      }
      setIsShowAddEditForm(false);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const updateCallForward = async (formData, id) => {
    try {
      const callForwardId = callForwardDetails?.id || id;
      setLoading(true);
      const propertyId = process.env.REACT_APP_WESTONHALL_PROPERTY_ID;
      const url = process.env.REACT_APP_PROPERTY_API_URL + "v1/property-phones/" + propertyId + `/${callForwardId}`;
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      const response = await Axios.put(url, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response", response.data);
      const newCallForward = response.data.data;
      setCallForwardDetails(null);
      setIsShowAddEditForm(false);
      setCallForwardList((prevList) =>
        prevList.map((callForward) =>
          callForward.id === newCallForward.id ? newCallForward : callForward
        )
      );

      toast.success(response.data.message);
    } catch (error) {
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const deleteCallForward = async (formData) => {
    try {
      setLoading(true);
      const propertyId = process.env.REACT_APP_WESTONHALL_PROPERTY_ID;
      const url = process.env.REACT_APP_PROPERTY_API_URL + "v1/property-phones/" + propertyId + `/${callForwardId}`;
      const token = await getAccessTokenSilently({ audience: process.env.REACT_APP_AUTH0_AUDIENCE });
      const response = await Axios.delete(url, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response", response.data);
      setCallForwardId(null);
      setOpenCallForwardDeleteModal(false);
      setCallForwardList((prevList) =>
        prevList.filter((callForward) => callForward.id !== callForwardId)
      );

      toast.success(response.data.message);
    } catch (error) {
      setCallForwardId(null);
      setLoading(false);
      toast.error(error?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  const handleAddEditForm = (value) => {
    setIsShowAddEditForm(value);
    setCallForwardDetails(null);
  };

  const loaderHandler = (value) => {
    setLoading(value);
  };

  const handleCloseModal = () => {
    props?.hanldeCallForwardModal(false); // Close the modal
    setIsShowAddEditForm(false);
  };

  const setDetails = (value) => {
    setCallForwardDetails(value);
    setIsShowAddEditForm(true);
  };

  return (<div>
    {/* <Loader /> */}
    <Dialog
      open={props?.isCallForwardModalOpen}
      fullWidth
      maxWidth="sm"
      onClose={handleCloseModal}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp MobileForm"
    >
      {loading && <Loader />}
      {!isShowAddEditForm && (<CallForwardListing
        callForwardList={filteredCallForwardList}
        setDetails={setDetails}
        handleCloseModal={handleCloseModal}
        setIsShowAddEditForm={setIsShowAddEditForm}
        setCallForwardId={setCallForwardId}
        setOpenCallForwardDeleteModal={setOpenCallForwardDeleteModal}
        onSearch={handleSearch}
        searchQuery={searchQuery}
        updateCallForward={updateCallForward}
      />)}
      {isShowAddEditForm && (<CallForwardAddEdit
        callForwardDetails={callForwardDetails}
        handleAddEditForm={handleAddEditForm}
        handleCloseModal={handleCloseModal}
        AddCallForward={AddCallForward}
        updateCallForward={updateCallForward}
      />)}
    </Dialog>

    {/* Delete dialog */}

    <Dialog
      open={openCallForwardDeleteModal}
      fullWidth
      maxWidth="sm"
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      className="NewPopUp"
      onClose={(e) => { setOpenCallForwardDeleteModal(false); setCallForwardId(null); }}
    >
      <DialogTitle id="alert-dialog-title">
        Delete Number
        <button onClick={(e) => { setOpenCallForwardDeleteModal(false); setCallForwardId(null); }}>
          <X />
        </button>
      </DialogTitle>
      <DialogContent>
        <DialogContentText
          id="alert-dialog-description"
          className="ModalFormGroup"
          style={{ marginBottom: "0px", padding: "25px 0" }}
        >
          <label className="PopupBodyText">Are you sure you want to delete this item?</label>
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button className="CancelPopupBU" onClick={(e) => { deleteCallForward(); setOpenCallForwardDeleteModal(false); }}>Delete</Button>
        <Button className="SubmitPopupBU" onClick={(e) => { setOpenCallForwardDeleteModal(false); setCallForwardId(null); }}>Cancel</Button>
      </DialogActions>
    </Dialog>
  </div>);
};

export default CallForward;